import { isTravelTypeWithHousing } from '@repo/utils'
import React from 'react'
import { useIntl } from 'react-intl'

import AdminActionButton from '../admin-action/AdminActionButton'
import { AdminActionEnum } from '../admin-action/utils/admin-action-data'
import PingPongButton from '../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../utils/ping-pong-button-type.enum.ts'
import {
  ClientProposalOutputDto,
  TravelTypeEnum,
} from '../../../../../../lib/graphql'
import { useTravelTypeContext } from '../../../../../contexts'
import { IProposalInteractionsProps } from '../../../Proposal'

const UserWaitingHostBookingConfirmationFooter = ({
  adminActions,
  clientProposal,
}: {
  adminActions: IProposalInteractionsProps['adminActions']
  clientProposal: Pick<ClientProposalOutputDto, '_id' | 'permissions'>
}) => {
  const intl = useIntl()
  const { travelType } = useTravelTypeContext()

  const adminCanceledUserConfirmedBooking =
    adminActions?.adminCanceledUserConfirmedBooking

  const isEvent =
    travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT ||
    !isTravelTypeWithHousing(travelType)

  const buttonLabel = isEvent
    ? intl.formatMessage({
        id: 'ui.UserWaitingHostBookingConfirmationFooter.waitingHostBookingConfirmation.event',
        defaultMessage: 'En attente de réponse du prestataire',
      })
    : intl.formatMessage({
        id: 'ui.UserWaitingHostBookingConfirmationFooter.waitingHostBookingConfirmation.stay',
        defaultMessage: "En attente de réponse de l'hôte",
      })

  return (
    <div className='flex w-full flex-col gap-3 py-5'>
      <PingPongButton
        dataTestId='waiting-host-booking-confirmation-button'
        label={buttonLabel}
        type={PingPongButtonTypeEnum.WAITING}
      />

      {adminCanceledUserConfirmedBooking &&
        clientProposal.permissions?.canCancelUserConfirmedBooking && (
          <AdminActionButton
            adminAction={AdminActionEnum.CANCEL_USER_CONFIRMED_BOOKING}
            onClickConfirm={() =>
              adminCanceledUserConfirmedBooking.callback({
                clientProposalId: clientProposal._id,
              })
            }
            isLoading={adminCanceledUserConfirmedBooking.isLoading}
          />
        )}
    </div>
  )
}

export default UserWaitingHostBookingConfirmationFooter
